import { forwardRef, type SVGProps } from 'react';

export const PartlySettledIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function PartlySettledIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.1834 20.8166C10.0632 20.2298 10 19.6223 10 19C10 18.3126 10.0771 17.6432 10.223 17H6V15H10.9355C11.2974 14.2719 11.7549 13.5997 12.2917 13H6V11H14.8728C16.109 10.3609 17.5124 10 19 10C19.6874 10 20.3568 10.0771 21 10.223V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22ZM6 9V7H18V9H6ZM22.5355 15.4645C21.5979 14.5268 20.3261 14 19 14V19V24C20.3261 24 21.5979 23.4732 22.5355 22.5355C23.4732 21.5979 24 20.3261 24 19C24 17.6739 23.4732 16.4021 22.5355 15.4645Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
});
